import { render } from "./RepairType.vue?vue&type=template&id=52e2498e"
import script from "./RepairType.vue?vue&type=script&lang=js"
export * from "./RepairType.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__